<template>
  <div>
    <el-form :model="form" ref="formRef" :inline="true">
      <el-form-item>
        <el-button type="primary" size="mini" @click="handleDownloadTemplate">下载名单模板</el-button>
      </el-form-item>
      <el-form-item>
        <el-upload
          action="#"
          :show-file-list="false"
          :http-request="handleUpload"
          :before-upload="beforeUpload"
          accept=".xlsx,.xls"
        >
          <el-button size="mini" type="primary" :loading="uploading">导入名单</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import meetingSignUpApi from '@/api/meeting/meetingSignUp'

export default {
  data() {
    return {
      form: {},
      uploading: false
    }
  },
  methods: {
    handleDownloadTemplate() {
      meetingSignUpApi.downloadExcelTemplate()
    },
    beforeUpload(file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'application/vnd.ms-excel'
      if (!isExcel) {
        this.$message.error('请上传 Excel 文件（.xlsx 或 .xls）')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
        return false
      }
      return true
    },
    handleUpload({ file }) {
      const formData = new FormData()
      formData.append('file', file)
      this.uploading = true
      meetingSignUpApi
        .importName(formData)
        .then(res => {
          if (res.code === '0') {
            this.$message.success('导入' + (res.data || 0) + '条数据')
            this.$emit('created')
          } else {
            this.$message.error(res.msg || res.message || '导入失败')
          }
        })
        .catch(err => {
          this.$message.error(err.msg || err.message || '导入失败')
        })
        .finally(() => {
          this.uploading = false
        })
    }
  }
}
</script>
